import React from "react";
import { Box } from "@chakra-ui/react";
import { DragDrop } from "@uppy/react";
import PreloaderWrapper from "../Preloader/PreloaderWrapper";
import Preloader from "../Preloader/Preloader";

import "@uppy/core/dist/style.css";

const fileSelectorWrapper = {
  position: "relative",
  flex: "1",
  "> div": {
    height: "full",
  },
  ".uppy-DragDrop-container": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "lg",
    border: "2px dashed",
    borderColor: "whiteAlpha.400",
    backgroundColor: "blackAlpha.300",
    minHeight: "100px",
    cursor: "pointer",
    _focus: {
      outline: "none",
      boxShadow: "outline",
    },
    "&.uppy-DragDrop--isDraggingOver": {
      backgroundColor: "blackAlpha.500",
      borderColor: "whiteAlpha.700",
    },
  },
  ".uppy-DragDrop-inner": {
    padding: "4",
    textAlign: "center",
  },
  ".uppy-DragDrop-arrow": {
    fill: "currentColor",
    width: "24px",
    height: "24px",
    marginBottom: "3",
  },
  ".uppy-DragDrop-label": {},
  ".uppy-DragDrop-browse": {
    color: "brand.primary",
    cursor: "pointer",
  },
  ".uppy-DragDrop-note": {
    display: "block",
    fontSize: "sm",
    color: "gray.200",
    marginTop: "3",
  },
};

const UppyDropFile = ({
  isLoading,
  uppy,
  note,
  locale,
  inputName,
  allowMultipleFiles,
  onDragLeave = () => {},
  onDragOver = () => {},
  onDrop = () => {},
  ...props
}) => {
  return (
    <Box {...props} sx={{ ...fileSelectorWrapper, ...props.sx }}>
      <DragDrop
        uppy={uppy}
        note={note}
        locale={locale}
        inputName={inputName}
        allowMultipleFiles={allowMultipleFiles}
        width="100%"
        height="100%"
        onDragLeave={onDragLeave}
        onDragOver={onDragOver}
        onDrop={onDrop}
      />
      {isLoading ? (
        <PreloaderWrapper>
          <Preloader />
        </PreloaderWrapper>
      ) : null}
    </Box>
  );
};

export default UppyDropFile;
